import { render } from "./GISEditorSigpac.vue?vue&type=template&id=3c2c23ba"
import script from "./GISEditorSigpac.vue?vue&type=script&lang=js"
export * from "./GISEditorSigpac.vue?vue&type=script&lang=js"

import "./GISEditorSigpac.vue?vue&type=style&index=0&id=3c2c23ba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__